import { render } from "./TipoVeiculo.vue?vue&type=template&id=505840a4&scoped=true"
import script from "./TipoVeiculo.vue?vue&type=script&lang=js"
export * from "./TipoVeiculo.vue?vue&type=script&lang=js"

import "./TipoVeiculo.vue?vue&type=style&index=0&id=505840a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505840a4"]])

export default __exports__